/**
 * 扩展配置服务 - 从 Supabase 动态获取扩展下载 URL
 */

import { supabase } from '@ext-bookmark/shared/api';

export async function getExtensionDownloadUrl(): Promise<string | null> {
  if (!supabase) return null;
  const { data, error } = await supabase
    .from('extension_config')
    .select('value')
    .eq('key', 'extension_download_url')
    .maybeSingle();
  if (error) return null;
  return data?.value ?? null;
}
